import type { NftInclude } from '@mogul/api-client';

import { nftsApi } from '../api';

export const getNftIfMinted = async (
  contractAddress: string,
  id: string,
  include?: NftInclude[],
) => {
  try {
    const res = await nftsApi.getNftIfMinted({
      contractAddress,
      id,
      include,
    });

    return res?.data?.data;
  } catch (err) {
    /** @ts-expect-error */
    if (err?.response?.status === 404) {
      console.log(`NFT ${id} of contract ${contractAddress} not found, 404`);
      return null;
    }
    throw err;
  }
};

export const getDeletedNftIds = async (contractAddress: string) => {
  try {
    const res = await nftsApi.getDeletedNftIds({ contractAddress });

    return res?.data;
  } catch (err) {
    console.log(`Failed to get deleted NFTs of contract ${contractAddress}`);
    return [];
  }
};
